export default {
  Title:
    "Are you satisfied about MISA meInvoice - Process invoice and share products with everyone?",
  SurveyEvaluate:
    "Assess satisfaction and willingness to share MISA meInvoice - Processing invoices to everyone:",
  VerySatisfied: "Very satisfied",
  Unsatisfied: "Dissatisfied",
  Opinion: "Comments",
  Close: "Close",
  SendFeedback: "Send feedback",
  TextThanks:
    "Your comments and reviews will be very helpful in the process of improving and developing the product to give you the best experience.",
  ReasonUnsatisfied:
    "Please indicate why you are not satisfied with the product",
  ThankOption:
    "Thank you for your trust, what suggestions would you like to make the product better and better?",
  Send: "Submit",
  Cancel: "Cancel",
  Thanks: "Thank You",
  EvaluationScore: "Evalution score",
  QuestionOption: "Further comments (if any)?",
  ReasonType: "What kind of reason?",
  YourOpinion: "Your enquiry",
  NeedVoteBeforeSend: "You need to score satisfaction before submitting feedback",
  RatingTemporarilyUnavailableMessage: "The rating feature is temporarily unavailable. Please try again in a few minutes.",
  RatingActionFailedTitle: "Unable to perform the rating action"
};
